import React from 'react';
import { PropTypes } from 'prop-types';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const Footer = ({ send, cancel }) =>
  (<DialogActions>
    <Button onClick={cancel} color="secondary">
      Annuler
    </Button>
    <Button onClick={send} color="primary">
      Valider
    </Button>
  </DialogActions>);

Footer.propTypes = {
  send: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};
export default Footer;
